import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { axiosDefaultApi } from 'src/lib/axios';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';


const deleteLineType = ({lineTypeId}: {lineTypeId:number}): Promise<string> => {
  return axiosDefaultApi.delete(`/api/LineTypes/DeleteLineType/${lineTypeId}`);
};

type QueryFnType = typeof deleteLineType;

type UseDeleteLineTypeOptions = {
  lineTypeId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeleteLineType = ({ config }: UseDeleteLineTypeOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
      onError: (error:AxiosError<any>) => {
        if(error.response && error.response.data && error.response.data.message) {
          const responseMessage = error.response?.data.message;
          console.log(responseMessage)
          addNotification(responseMessage.toString(), 500);
          setIsNotificationVisible(true)
        }
        },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllLineTypes"]);
            addNotification(`Το Είδος Συσκευής Διαγράφηκε.`, 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: deleteLineType,
    })
}